module.exports = __webpack_public_path__ + "fonts/fa-light-300.86683af0.woff2";